// removed by extract-text-webpack-plugin
module.exports = {"Bluecheese":"#615CFF","LightestAccessible":"#6F7781","container":"G70f439","month":"G3ab819","day":"G7b52ec","dayNumeric":"Gb1044a"};